
import { motion } from "framer-motion";

export const ArabicProcessSteps = () => {
  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold mb-4 text-blue-800">عملية تقديم طلب القرض في فنلندا</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">1</div>
          <h3 className="text-lg font-medium mb-2">إكمال الطلب</h3>
          <p className="text-gray-600">املأ طلبًا واحدًا لمقارنة عروض قروض متعددة.</p>
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">2</div>
          <h3 className="text-lg font-medium mb-2">استلام العروض</h3>
          <p className="text-gray-600">تقوم البنوك بمراجعة طلبك وتقديم عروض قروض في غضون 24 ساعة.</p>
        </div>
        <div className="bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
          <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 text-blue-600 mb-4">3</div>
          <h3 className="text-lg font-medium mb-2">قبول أفضل عرض</h3>
          <p className="text-gray-600">قارن الشروط واقبل العرض الذي يلبي احتياجاتك بشكل أفضل.</p>
        </div>
      </div>
    </div>
  );
};
